import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';
import { toast } from 'sonner';
import { Download, FileSpreadsheet } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MONTHS = [
  'Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie',
  'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'
];

const ExportMonthDialog = ({ endpoint, filenamePrefix, triggerLabel = 'Export Excel', testId }) => {
  const now = new Date();
  const [open, setOpen] = useState(false);
  const [year, setYear] = useState(String(now.getFullYear()));
  const [month, setMonth] = useState(String(now.getMonth() + 1));
  const [downloading, setDownloading] = useState(false);

  const years = [];
  for (let y = now.getFullYear(); y >= now.getFullYear() - 3; y--) years.push(String(y));

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const response = await axios.get(
        `${API}${endpoint}?year=${year}&month=${month}`,
        { withCredentials: true, responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filenamePrefix}_${year}_${String(month).padStart(2, '0')}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Export descărcat');
      setOpen(false);
    } catch (e) {
      toast.error('Eroare la export');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          className="border-green-600 text-green-700 hover:bg-green-50"
          data-testid={testId}
        >
          <FileSpreadsheet className="w-4 h-4 mr-2" />
          {triggerLabel}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Outfit' }}>Export lunar Excel</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div>
            <Label>Lună</Label>
            <Select value={month} onValueChange={setMonth}>
              <SelectTrigger data-testid="export-month-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {MONTHS.map((m, i) => (
                  <SelectItem key={i} value={String(i + 1)}>{m}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>An</Label>
            <Select value={year} onValueChange={setYear}>
              <SelectTrigger data-testid="export-year-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {years.map((y) => (<SelectItem key={y} value={y}>{y}</SelectItem>))}
              </SelectContent>
            </Select>
          </div>
          <Button
            onClick={handleDownload}
            disabled={downloading}
            className="w-full bg-green-600 hover:bg-green-700 text-white"
            data-testid="confirm-export-button"
          >
            <Download className="w-4 h-4 mr-2" />
            {downloading ? 'Se descarcă...' : 'Descarcă Excel'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ExportMonthDialog;
